export const TEST_ID = 'drawingModeDropdown';

export { DRAWING_MODE } from 'components/Map/constants';
